// Sample slide data for testing the Duarte-style slide analysis view
export const sampleSlides = [
  {
    slide_number: 1,
    layout_type: "Title Slide",
    shapes_count: 3,
    text_boxes: 2,
    images: 0,
    charts: 0,
    tables: 0,
    visual_density: "balanced",
    text_content: "SLIDE TITLE: Quarterly Business Review\n\nQ4 2024 Results",
    thumbnail_url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450'%3E%3Crect width='800' height='450' fill='%234f46e5'/%3E%3Ctext x='50%25' y='40%25' font-family='Arial' font-size='48' fill='white' text-anchor='middle'%3EQuarterly Business Review%3C/text%3E%3Ctext x='50%25' y='60%25' font-family='Arial' font-size='32' fill='white' text-anchor='middle'%3EQ4 2024 Results%3C/text%3E%3C/svg%3E",
    recommendations: {
      newTitle: "Q4 2024: Quarterly Business Review",
      content_refinements: [
        "Add date and presenter name for context",
        "Include a compelling tagline below title",
        "Ensure brand colors are used consistently"
      ],
      visual_content: [
        "Add company logo in top-right corner",
        "Consider subtle background gradient for visual interest"
      ]
    }
  },
  {
    slide_number: 2,
    layout_type: "Content Slide",
    shapes_count: 8,
    text_boxes: 5,
    images: 1,
    charts: 0,
    tables: 0,
    visual_density: "visual-heavy",
    text_content: "SLIDE TITLE: Key Achievements\n\n• Revenue increased by 45% year-over-year\n• Expanded to 3 new markets\n• Launched 5 new product features\n• Customer satisfaction score improved to 92%\n• Team grew from 50 to 85 employees",
    thumbnail_url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450'%3E%3Crect width='800' height='450' fill='%23f3f4f6'/%3E%3Ctext x='50' y='60' font-family='Arial' font-size='36' font-weight='bold'%3EKey Achievements%3C/text%3E%3Ctext x='80' y='120' font-family='Arial' font-size='20'%3E• Revenue increased by 45%25%3C/text%3E%3Ctext x='80' y='160' font-family='Arial' font-size='20'%3E• Expanded to 3 new markets%3C/text%3E%3Ctext x='80' y='200' font-family='Arial' font-size='20'%3E• Launched 5 new features%3C/text%3E%3Crect x='550' y='100' width='200' height='150' fill='%2310b981' rx='10'/%3E%3C/svg%3E",
    recommendations: {
      newTitle: "2024 Key Achievements: Growth Across All Metrics",
      content_refinements: [
        "Reduce to 4 key achievements - aim for 6 words per line",
        "Use larger font sizes (18-20pt minimum) for better readability",
        "Add icons next to each bullet for visual interest",
        "Strengthen visual hierarchy to highlight most important metric"
      ],
      visual_content: [
        "Replace generic image with data visualization showing 45% growth",
        "Add supporting visual to reinforce growth narrative",
        "Consider 2x2 grid layout with icons for cleaner presentation"
      ]
    }
  },
  {
    slide_number: 3,
    layout_type: "Content Slide",
    shapes_count: 12,
    text_boxes: 8,
    images: 0,
    charts: 1,
    tables: 0,
    visual_density: "visual-heavy",
    text_content: "SLIDE TITLE: Revenue Growth\n\nQ1: $2.5M\nQ2: $3.1M\nQ3: $3.8M\nQ4: $4.2M\n\nTotal Annual Revenue: $13.6M",
    thumbnail_url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450'%3E%3Crect width='800' height='450' fill='%23ffffff'/%3E%3Ctext x='50' y='60' font-family='Arial' font-size='36' font-weight='bold'%3ERevenue Growth%3C/text%3E%3Crect x='100' y='300' width='80' height='50' fill='%234f46e5'/%3E%3Crect x='200' y='250' width='80' height='100' fill='%234f46e5'/%3E%3Crect x='300' y='200' width='80' height='150' fill='%234f46e5'/%3E%3Crect x='400' y='150' width='80' height='200' fill='%234f46e5'/%3E%3Ctext x='50' y='380' font-size='16'%3EQ1%3C/text%3E%3Ctext x='150' y='380' font-size='16'%3EQ2%3C/text%3E%3Ctext x='250' y='380' font-size='16'%3EQ3%3C/text%3E%3Ctext x='350' y='380' font-size='16'%3EQ4%3C/text%3E%3C/svg%3E",
    recommendations: {
      newTitle: "Revenue Growth Trajectory: $13.6M Annual Revenue",
      content_refinements: [
        "Add growth percentages between quarters for context",
        "Include YoY comparison if available for perspective",
        "Add brief insight or callout highlighting the trend"
      ],
      visual_content: [
        "Add data labels directly on chart bars",
        "Maximize chart size to 70% of slide area",
        "Include trend line showing growth momentum",
        "Add annotations for significant business events"
      ]
    }
  },
  {
    slide_number: 4,
    layout_type: "Content Slide",
    shapes_count: 6,
    text_boxes: 4,
    images: 0,
    charts: 0,
    tables: 1,
    visual_density: "balanced",
    text_content: "SLIDE TITLE: Market Expansion Strategy\n\nPhase 1: North America (Complete)\nPhase 2: Europe (In Progress)\nPhase 3: Asia Pacific (Planned Q2 2025)\n\nKey markets: UK, Germany, France",
    thumbnail_url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450'%3E%3Crect width='800' height='450' fill='%23f9fafb'/%3E%3Ctext x='50' y='60' font-family='Arial' font-size='36' font-weight='bold'%3EMarket Expansion%3C/text%3E%3Crect x='80' y='120' width='640' height='50' fill='%2310b981' stroke='%23059669' stroke-width='2'/%3E%3Crect x='80' y='180' width='640' height='50' fill='%23fbbf24' stroke='%23f59e0b' stroke-width='2'/%3E%3Crect x='80' y='240' width='640' height='50' fill='%23e5e7eb' stroke='%239ca3af' stroke-width='2'/%3E%3C/svg%3E",
    recommendations: {
      newTitle: "Global Expansion Roadmap: Three-Phase Strategy",
      content_refinements: [
        "Add specific success metrics for each phase",
        "Include timeline visualization showing key milestones",
        "Specify revenue targets per region for clarity"
      ],
      visual_content: [
        "Add world map highlighting target regions in background",
        "Convert to horizontal timeline showing phases visually",
        "Use status badges (✓ Complete, → In Progress, ○ Planned)"
      ]
    }
  },
  {
    slide_number: 5,
    layout_type: "Content Slide",
    shapes_count: 5,
    text_boxes: 3,
    images: 2,
    charts: 0,
    tables: 0,
    visual_density: "text-heavy",
    text_content: "SLIDE TITLE: Customer Success Stories\n\n\"The platform has transformed how we work. Productivity is up 60% and our team loves it.\"\n- Sarah Johnson, CEO at TechCorp\n\n\"Best investment we made this year. ROI was achieved in just 3 months.\"\n- Michael Chen, CTO at InnovateNow",
    thumbnail_url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450'%3E%3Crect width='800' height='450' fill='%23fef3c7'/%3E%3Ctext x='50' y='60' font-family='Arial' font-size='36' font-weight='bold'%3ECustomer Success%3C/text%3E%3Crect x='80' y='120' width='300' height='150' fill='white' stroke='%23fbbf24' stroke-width='3' rx='10'/%3E%3Crect x='420' y='120' width='300' height='150' fill='white' stroke='%23fbbf24' stroke-width='3' rx='10'/%3E%3C/svg%3E",
    recommendations: {
      newTitle: "Customer Success: 60% Productivity Gains, 3-Month ROI",
      content_refinements: [
        "Highlight key metrics (60%, 3 months) in bold or color",
        "Add context about company size or industry for credibility",
        "Include customer company logos for brand recognition"
      ],
      visual_content: [
        "Add large quotation marks for visual emphasis",
        "Use professional customer headshots if available",
        "Add company logos next to each testimonial",
        "Ensure adequate white space around elements"
      ]
    }
  }
];

export const sampleAnalyses = {
  0: {
    slideOverview: {
      slideNumber: 1,
      contentSummary: "Title slide introducing the Q4 2024 quarterly business review. Sets the tone for the presentation.",
      slidePurpose: "Opening & Context Setting",
      effectiveness: "high",
      priority: "optional"
    },
    contentAnalysis: {
      textContent: {
        clarity: "Excellent - clear and concise",
        organization: "Well structured",
        length: "appropriate",
        keyMessages: ["Q4 2024 business results presentation"],
        improvements: [
          "Consider adding a date or presenter name",
          "Add a subtle tagline or company logo"
        ]
      },
      visualElements: {
        images: { count: 0, relevance: "N/A", quality: "N/A", recommendations: [] },
        charts: { count: 0, effectiveness: "N/A", clarity: "N/A", improvements: [] },
        tables: { count: 0, readability: "N/A", structure: "N/A", improvements: [] }
      }
    },
    designRecommendations: {
      layout: {
        currentLayout: "Title Slide",
        effectiveness: "Good",
        recommendedLayout: "Keep current layout",
        specificChanges: [
          "Ensure title is prominent and centered",
          "Add visual interest with a gradient or background image"
        ],
        visualHierarchy: "Clear hierarchy with title and subtitle"
      }
    },
    quickWins: [
      "Add company logo in corner",
      "Include presentation date"
    ],
    priorityFixes: [
      "Ensure brand colors are used consistently"
    ]
  },
  1: {
    slideOverview: {
      slideNumber: 2,
      contentSummary: "Highlights key achievements including 45% revenue growth, market expansion, and team growth.",
      slidePurpose: "Key Achievements Summary",
      effectiveness: "medium",
      priority: "important"
    },
    contentAnalysis: {
      textContent: {
        clarity: "Good but could be more concise",
        organization: "Bullet points are clear",
        length: "too long",
        keyMessages: ["45% revenue growth", "Market expansion", "Product innovation", "Team growth"],
        improvements: [
          "Reduce bullet points to 3-4 most impactful achievements",
          "Use larger font sizes for better readability",
          "Consider using icons next to each bullet point",
          "Break into multiple slides if needed"
        ]
      },
      visualElements: {
        images: {
          count: 1,
          relevance: "Moderate",
          quality: "Unclear from data",
          recommendations: [
            "Replace generic image with data visualization",
            "Consider using icons for each achievement",
            "Add a timeline graphic showing progress"
          ]
        },
        charts: { count: 0, effectiveness: "N/A", clarity: "N/A", improvements: [] },
        tables: { count: 0, readability: "N/A", structure: "N/A", improvements: [] }
      }
    },
    designRecommendations: {
      layout: {
        currentLayout: "Content Slide",
        effectiveness: "Needs improvement - too text heavy",
        recommendedLayout: "Icon Grid or Split Content",
        specificChanges: [
          "Use a 2x2 grid with icons for top 4 achievements",
          "Increase white space between elements",
          "Use color coding for different achievement categories",
          "Add visual metrics or small charts for quantitative achievements"
        ],
        visualHierarchy: "Needs stronger hierarchy - all bullets have equal weight"
      }
    },
    quickWins: [
      "Add icons to each bullet point",
      "Increase font size to 18-20pt minimum",
      "Reduce to 4 key achievements"
    ],
    priorityFixes: [
      "Redesign layout to reduce text density",
      "Add visual elements to support key metrics",
      "Improve visual hierarchy to highlight most important achievement"
    ],
    visualSuggestions: {
      needsVisual: true,
      recommendedImage: {
        purpose: "Celebrate Growth",
        description: "Modern abstract illustration of upward growth trajectory with geometric shapes in brand colors, showing momentum and success",
        placement: "Right side or background",
        priority: "medium",
        reasoning: "Visual representation of growth will make the achievements more memorable and impactful"
      }
    }
  },
  2: {
    slideOverview: {
      slideNumber: 3,
      contentSummary: "Shows quarterly revenue progression from Q1 to Q4, demonstrating consistent growth to $13.6M annual revenue.",
      slidePurpose: "Financial Performance Visualization",
      effectiveness: "high",
      priority: "important"
    },
    contentAnalysis: {
      textContent: {
        clarity: "Clear and data-focused",
        organization: "Well organized",
        length: "appropriate",
        keyMessages: ["Consistent quarterly growth", "$13.6M total annual revenue"],
        improvements: [
          "Add growth percentages between quarters",
          "Include YoY comparison if available",
          "Add a brief insight or callout about the trend"
        ]
      },
      visualElements: {
        images: { count: 0, relevance: "N/A", quality: "N/A", recommendations: [] },
        charts: {
          count: 1,
          effectiveness: "Good - shows clear upward trend",
          clarity: "Clear",
          improvements: [
            "Add data labels on each bar",
            "Include a trend line",
            "Use gradient colors to emphasize growth",
            "Add annotations for significant events"
          ]
        },
        tables: { count: 0, readability: "N/A", structure: "N/A", improvements: [] }
      }
    },
    designRecommendations: {
      layout: {
        currentLayout: "Content Slide",
        effectiveness: "Very effective for data visualization",
        recommendedLayout: "Keep current, optimize chart area",
        specificChanges: [
          "Maximize chart size - use 70% of slide",
          "Add subtle grid lines for easier reading",
          "Include growth percentage annotations",
          "Add a key insight callout box"
        ],
        visualHierarchy: "Good - chart is focal point"
      }
    },
    quickWins: [
      "Add data labels to bars",
      "Increase chart size",
      "Add growth % between quarters"
    ],
    priorityFixes: [
      "Ensure chart colors match brand palette",
      "Add meaningful annotations"
    ]
  },
  3: {
    slideOverview: {
      slideNumber: 4,
      contentSummary: "Outlines three-phase market expansion strategy with focus on North America, Europe, and Asia Pacific.",
      slidePurpose: "Strategy & Roadmap Communication",
      effectiveness: "medium",
      priority: "important"
    },
    contentAnalysis: {
      textContent: {
        clarity: "Clear strategic phases",
        organization: "Logical progression",
        length: "appropriate",
        keyMessages: ["Three-phase expansion", "Europe in progress", "APAC planned for Q2 2025"],
        improvements: [
          "Add specific success metrics for each phase",
          "Include timeline visualization",
          "Specify resources required",
          "Add revenue targets per region"
        ]
      },
      visualElements: {
        images: { count: 0, relevance: "N/A", quality: "N/A", recommendations: ["Add world map highlighting target regions"] },
        charts: { count: 0, effectiveness: "N/A", clarity: "N/A", improvements: [] },
        tables: {
          count: 1,
          readability: "Good status indicators",
          structure: "Simple and clear",
          improvements: [
            "Add visual status indicators (checkmark, progress bar, clock icon)",
            "Include target market size or TAM",
            "Add expected revenue per region",
            "Use color coding for phase status"
          ]
        }
      }
    },
    designRecommendations: {
      layout: {
        currentLayout: "Content Slide",
        effectiveness: "Functional but could be more visual",
        recommendedLayout: "Timeline or Roadmap Layout",
        specificChanges: [
          "Convert to horizontal timeline showing phases",
          "Add world map visual in background",
          "Use status badges (Complete, In Progress, Planned)",
          "Create visual roadmap with milestones"
        ],
        visualHierarchy: "Adequate but could emphasize current phase more"
      }
    },
    quickWins: [
      "Add status icons (✓, →, ○) for each phase",
      "Color code phases by status",
      "Bold the current phase"
    ],
    priorityFixes: [
      "Convert to visual timeline/roadmap format",
      "Add world map graphic",
      "Include key milestones and dates"
    ],
    visualSuggestions: {
      needsVisual: true,
      recommendedImage: {
        purpose: "Global Expansion Visualization",
        description: "Minimalist world map with highlighted regions in brand colors, showing expansion phases with clean, modern design",
        placement: "Background or right side",
        priority: "high",
        reasoning: "Geographic visual will make the expansion strategy more concrete and memorable for stakeholders"
      }
    }
  },
  4: {
    slideOverview: {
      slideNumber: 5,
      contentSummary: "Features customer testimonials from executives highlighting productivity gains and ROI achievements.",
      slidePurpose: "Social Proof & Credibility",
      effectiveness: "high",
      priority: "important"
    },
    contentAnalysis: {
      textContent: {
        clarity: "Excellent - powerful testimonials",
        organization: "Well structured with attribution",
        length: "appropriate",
        keyMessages: ["60% productivity increase", "3-month ROI", "Strong customer satisfaction"],
        improvements: [
          "Add customer company logos",
          "Include customer photos if available",
          "Add context about company size or industry",
          "Consider adding a third testimonial for balance"
        ]
      },
      visualElements: {
        images: {
          count: 2,
          relevance: "High if they're customer photos",
          quality: "Unknown",
          recommendations: [
            "Use professional headshots of customers",
            "Add company logos next to testimonials",
            "Ensure images are high resolution",
            "Consider replacing with actual customer photos if not already"
          ]
        },
        charts: { count: 0, effectiveness: "N/A", clarity: "N/A", improvements: [] },
        tables: { count: 0, readability: "N/A", structure: "N/A", improvements: [] }
      }
    },
    designRecommendations: {
      layout: {
        currentLayout: "Content Slide",
        effectiveness: "Good - testimonial format is clear",
        recommendedLayout: "Card-based testimonial layout",
        specificChanges: [
          "Use card design for each testimonial",
          "Add large quotation marks for visual emphasis",
          "Include customer photos and company logos",
          "Use subtle background color or border to separate testimonials",
          "Add star ratings or satisfaction scores if applicable"
        ],
        visualHierarchy: "Good but could emphasize key metrics (60%, 3 months)"
      }
    },
    quickWins: [
      "Add large quote marks",
      "Highlight key metrics (60%, 3 months) in bold or color",
      "Add company logos"
    ],
    priorityFixes: [
      "Ensure professional customer photos are used",
      "Add visual separation between testimonials",
      "Include company context (industry, size)"
    ]
  }
};
